<script setup lang="ts">
import { useSlots } from 'vue';
import UploadUtilityOrderModal from '@utilities/components/Modals/UploadUtilityOrderModal/UploadUtilityOrderModal.vue';
import AppHeader from '~/components/navigation/appHeader/AppHeader.vue';
import { useMainStore } from '~/stores/mainStore';
import type { User } from '~/types/user';
const { $sanctumAuth } = useNuxtApp();
const auth = useAuth();
const mainStore = useMainStore();
const { getAccountDetails, getSiteSettings, registerWebsocketEvents } =
  mainStore;
const slots = useSlots();
const toaster = useToaster();

getSiteSettings();

// Check if auth and user are properly initialised
if (!auth || !auth.user) {
  // Force logout if user is not available
  toaster.add('danger', 'Sorry, your session expired. Please login again.');
  setTimeout(() => {
    $sanctumAuth.logout();
  }, 3000);
} else {
  getAccountDetails();

  const user = auth.user as User;
  if (user && user.id && user.landlord && user.landlord.id) {
    registerWebsocketEvents(user.landlord.id);
  } else {
    // Force logout if user data is incomplete
    toaster.add('danger', 'Sorry, your session expired. Please login again.');
    setTimeout(() => {
      $sanctumAuth.logout();
    }, 3000);
  }
}

const hasNavSlot = computed(() => {
  return typeof slots.nav !== 'undefined';
});
</script>

<template>
  <div class="flex h-screen w-screen flex-col" data-cy="default">
    <div class="flex w-full">
      <AppHeader :show-side-bar-button="hasNavSlot" />
    </div>

    <div class="relative flex flex-1 overflow-hidden">
      <slot name="nav"></slot>
      <slot name="page"></slot>
    </div>

    <UploadUtilityOrderModal />
  </div>
</template>
